export default __webpack_public_path__ + "assets/webgl/scene-24.a379c5c7.glb";